// 開発環境のドメインを定義
const DEV_DOMAIN = "d37czbb0fntvxr.cloudfront.net";

// 現在のホスト名が開発環境のドメインと一致するか、localhostかをチェック
const isDevEnvironment =
  typeof window !== "undefined" &&
  (window.location.hostname === DEV_DOMAIN ||
    window.location.hostname === "localhost");

export const videoConfig = {
  hlsVideoUrl: isDevEnvironment
    ? "https://d3ukvpy47sydxb.cloudfront.net/videos/hls/topgun_concert_osaka.m3u8"
    : "https://d2cqeaqvjfsqr.cloudfront.net/videos/hls/topgun_concert_osaka.m3u8",
};
